export const ORIGINAL_TIME_ESTIMATE_WRAPPER_TEST_ID =
	'software-board.board-container.board.card-container.card.original-estimate-field.wrapper';

export const PLACEHOLDER = '2w 4d 6h 45m';

export const ORIGINAL_TIME_ESTIMATE_STATIC_TEST_ID =
	'software-board.common.fields.estimate-field.static.estimate-wrapper';
